import MaorButton from "./MaorButton";

export default MaorButton;